const bscMainnetAddresses = {
  TRAVA_TOKEN_ADDRESS: "0x0391bE54E72F7e001f6BBc331777710b4f2999Ef",
  BUSD_TOKEN_ADDRESS: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
  RENT_CONTRACT_ADDRESS: "0xEC04d3aDaFD3A352A8F8A836Dc6e62d94b7655Cd",
  KAWAII_CORE_ADDRESS: "0x527A7ec10Ef231ABB63b3d40F3f2dE8AC67c60f5",
  KAWAII_PROXY_CONTRACT_ADDRESS: "0xDA02dffBf90807d43E14aaDA8D6DaD931bc44c90",
  MULTI_CALL_ADDRESS: "0x956BBC80253755A48FBcCC6783BBB418C793A257",
  TOKEN_FAUCET_ADDRESS: "0xbf56d82d4C5f58ebd9eeAA74a77B8b52D154351F",
  TRAVA_AIRDROP_ADDRESS: "0x81d19c26A9Df9D65691C329C435B9e76fe40573d",
  KAWAII_AIRDROP_ADDRESS: "0x710443C07311E05F81E56D7caD26188ccc26E7C6",
  KAWAII_TOKEN_ADDRESS: "0x257a8d1E03D17B8535a182301f15290F11674b53",

  NFT_CORE_ADDRESS: "0xAcBfD38C52Ae0344D47A7335D072DE5e3BC49f91",
  NFT_MANAGER_ADDRESS: "0xDE4e584DA24e9a528eCb3ffD0AaccBAEe2EfD137",
  NFT_COLLECTION_ADDRESS: "0x9C3E857eCe6224544aA77c1A6e500d8Fa1c9C102",
  NFT_SELL_ADDRESS: "0x39728bB898f6e44D0c0EC9d7934976e5ceA4DcAf",
  NFT_BUY_ADDRESS: "0xeD943988b57195A6668a212b189A2e9f8c151A61",
  NFT_SELL_COLLECTION_ADDRESS: "0x78DA1F3A42a0C9Cd3448c81081E5266d4567B3Ff",
  GIVEAWAY_ADDRESS: "0xd750a6C07314222643a039E8857Ab0C79AeaBB33",
  NFT_TRANSMUTATION_ADDRESS: "0xaAe9d2058f7721c17E58cf1e70052b4D3A8A9308",
  NFT_AUCTION_ADDRESS: "0xc715BBe707d39524173c0635611cD69c250c59CB",
  FLASH_SALE_ADDRESS: "0xb4442B7b9c92086F0f769872ae4360B688507229",
  BATTLE_HAND_ADDRESS: "0x0AF60b16E225Fc44c4d00a7CF1558eaA9d8e1193",
  NFT_FARMING_BASE_EXP: "0xc7a3a214206d6677b3321865AfbD84a417414Db3",
  STAKING_R_TRAVA_ADDRESS: "0x17b173D4B80B0B5BB7E0f1E99F5962f2D51799Eb",
  VE_TRAVA_ADDRESS: "0xedf6a93772EEcFB1300F61F6C1aE9680c33996A2",
  TRAVA_VE_TOKEN_ADDRESS: "0x0391bE54E72F7e001f6BBc331777710b4f2999Ef",
  RTRAVA_VE_TOKEN_ADDRESS: "0x170772A06aFfC0d375cE90Ef59C8eC04c7ebF5D2",
  VE_TRAVA_MARKETPLACE_ADDRESS: "0x65c62822940C1a57C90Ac8BF0874730624ec7Fb7",

  NFT_TICKET: "0xaDD13E50CbFaf76435EeD7b3b7624a7bE6Ba65da",
  NFT_TICKET_MANAGER: "0xECCDb13B0d284068000791214171639a65620cc6",
  NFT_TICKET_MARKETPLACE: "0xeB3fD6514280A2EBc0aF3bb40299B80c04D11D29",
  NFT_TICKET_COUNTER: "0x2a60BEe04368337b91feeED8fDBaD191aDb53888",
  NFT_TICKET_STAKING: "0x628CfD206c447bc1f0d00de49eF489C37889bb81",
  USDT_TEST: "0x55d398326f99059ff775485246999027b3197955",
  BOX_SALE: "0x7dA7Df44307d63bd4dd3E2416dFF7349F8604514",

  PANCAKE_ROUTER: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
  NFT_TICKET_COIN: "0x7f3FCCcb1B74ff7198D9466789E3f39ff2882e20",
  PANCAKE_PAIR: "0xDdaC44D0D93A031a49a741C257c512377d66B20b",
  NFT_DEX: "0x36145DeB5cA4eB7Ca623352aD9f538E71B21FD16",

  DILUTION_STAKING: "0x9E7e2fF72f1e3C031c14A53673036a922d349f9E",
  TRAVA_DILUTION_COIN: "0x0391bE54E72F7e001f6BBc331777710b4f2999Ef", // just trava
};

export default bscMainnetAddresses;
